import auth from './es-MX/auth.json';
import emailValidationPage from './es-MX/emailValidationPage.json';
import links from './es-MX/links.json';
import remoteActivation from './es-MX/remoteActivation.json';
import site from './es-MX/site.json';
import tags from './es-MX/tags.json';

export default { auth, emailValidationPage, links, remoteActivation, site, tags };
